import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/analytics-task-manager")({
    validateSearch: (search: Record<string, unknown>) => ({taskId: typeof search.taskId === "string" ? search.taskId : ""}),
    loader: ({context}) => ({
        accessToken: context.authenticationStatus.accessToken,
        intellsysBaseUrl: context.intellsysBaseUrl,
    }),
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
